import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'
import { useParams } from 'react-router-dom'

import { WrapperButton } from 'components/page/ForeignProfile/ChatButtonPhoto/ChatButtonPhoto.styled'
import { useAuthorizationBaseUrl } from 'components/page/ForeignProfile/hooks/useAuthorizationBaseUrl'
import { chatPath, contactPath } from 'components/paths'
import { SendMessageSvg } from 'components/presentational/svg/SendMessageSvg'
import { mergeAllUrls } from 'functions/mergeAllUrls'

export const ChatButtonPhoto: FC = () => {
  const { userId } = useParams<{ userId: string }>()
  const url = useAuthorizationBaseUrl(
    mergeAllUrls(chatPath, userId, contactPath)
  )

  return (
    <WrapperButton to={url} data-name={`open-messenger-with-${userId}-action`}>
      <FormattedMessage
        id="photo_rating.match_modal.button"
        defaultMessage="Написать сообщение"
      />
      <SendMessageSvg />
    </WrapperButton>
  )
}
